// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/IBMPlexSansThai-Medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/IBMPlexSansThai-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/IBMPlexSansThai-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/IBMPlexSansThai-Medium.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'Noto SansThai';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    src: local('☺'), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff'), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype'), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('svg');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
}

html, body, #root {
    height: 100%;
    background-color: #F9FBFD;
    font-family: 'Noto SansThai' !important;
}

#root {
    min-height: 100%;
    height: auto;
    display: flex;
    flex-direction: column;
}

#body, .p-top {
    padding-top: 55px;
}

#body {
    min-height: calc(100% - 50px);
}

.fw-bold {
    font-weight: 600 !important;
}

.rounded-25 {
    border-radius: 10% !important;
}

.rounded-left {
    border-radius: .25rem 0 0 .25rem !important;
}

.rounded-right-white {
    border-right: 1px solid #fff;
    ;
}

.pointer {
    cursor: pointer;
}

.cursor-default {
    cursor: default;
}

.min-width-nav {
    min-width: calc((100vw - 780px) / 2);
}

.bg-yellow {
    background-color: #FFC107;
}

.dropdown-toggle.toggle-end::after {
    float: right;
    margin-top: 10px;
}

.thumbnail-card {
    width: auto;
    height: 480px;
    padding-top: 480px;
    position: relative;
}

.thumbnail-img {
    border-top-left-radius: calc(0.25rem - 1px);
    border-top-right-radius: calc(0.25rem - 1px);
    object-fit: cover;
    vertical-align: bottom;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
    z-index: 0;
}

.text-potion {
    color: #148B9E;
}

.text-gray {
    color: #DAE2EB;
}

.text-orange {
    color: #fa7300
}

.labels-block {
    display: inline-block;
    width: 40px;
    height: 10px;
    margin-right: 5px;
    vertical-align: top;
    margin-top: 2px;
}

.line-height-2 {
    line-height: 1.2;
}

.fs-7 {
    font-size: 0.8rem !important;
}

.navbar-nav.nav-main .nav-link.active {
    color: #FFFFFF;
}

.w-webkit-fill-available {
    width: -webkit-fill-available;
}

.btn-info-old {
    color: #fff;
    background-color: #17a2b8;
    border-color: #17a2b8;
}

.btn-info-old:not(:disabled):not(.disabled).active, .btn-info-old:not(:disabled):not(.disabled):active, .show>.btn-info-old.dropdown-toggle {
    color: #fff;
    background-color: #117a8b;
    border-color: #10707f;
}

.btn-info-old:hover {
    color: #fff;
    background-color: #138496;
    border-color: #117a8b;
}

.btn-info-old.focus, .btn-info-old:focus {
    color: #fff;
    background-color: #138496;
    border-color: #117a8b;
    box-shadow: 0 0 0 0.2rem rgb(58 176 195 / 50%);
}

.btn-egg {
    color: #212529;
    background-color: #FFECB2;
    border-color: #FFECB2;
}

.btn-egg:not(:disabled):not(.disabled).active, .btn-egg:not(:disabled):not(.disabled):active, .show>.btn-egg.dropdown-toggle {
    color: #212529;
    background-color: #ffe598;
    border-color: #fddb76;
}

.btn-egg:hover {
    color: #212529;
    background-color: #fcdf88;
    border-color: #ffe598;
}

.btn-egg.focus, .btn-egg:focus {
    color: #212529;
    background-color: #fcdf88;
    border-color: #ffe598;
    box-shadow: 0 0 0 0.2rem rgb(252 223 136 / 50%);
}

.modal-backdrop {
    background-color: #FFFFFF;
}

.modal-backdrop.show {
    opacity: .9;
}

.bg-sky {
    background-color: #F9FBFD;
}

.text-info-old {
    color: #148B9E;
}

.very-small {
    font-size: .8rem;
}

.min-height-90vh {
    min-height: 90vh;
}

.table {
    --bs-table-striped-bg: #F9FBFD;
}

.table-striped>tbody>tr:nth-of-type(odd) {
    --bs-table-accent-bg: var(--bs-table-striped-bg);
    color: var(--bs-table-striped-color);
}

.page-link {
    color: #212529;
}

.page-link:focus {
    color: #FFC107;
    background-color: #e9ecef;
    box-shadow: 0 0 0 0.25rem rgb(255 193 7 / 25%);
}

.page-link:hover {
    color: #FFC107;
    background-color: #e9ecef;
    border-color: #dee2e6;
}

.page-item.active .page-link {
    background-color: #FFC107;
    border-color: #FFC107;
}

.white-space-pre-wrap {
    white-space: pre-wrap;
}

.dropdown-toggle.toggle-end::after {
    float: right;
    margin-top: 10px;
}

.clear-block-user-search {
    position: absolute;
    right: 50px;
    top: 9px;
    z-index: 3;
}

@media (min-width: 992px) {
    .navbar-nav.nav-main .nav-link.active {
        border-bottom: 4px solid #FFFFFF;
    }
}`, "",{"version":3,"sources":["webpack://./src/css/main.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;IAC5B,4CAAgD;IAChD,0LAAuM;IACvM,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,uCAAuC;AAC3C;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,4BAA4B;;AAEhC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,2CAA2C;IAC3C,4CAA4C;IAC5C,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,+CAA+C;AACnD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gDAAgD;IAChD,oCAAoC;AACxC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,UAAU;AACd;;AAEA;IACI;QACI,gCAAgC;IACpC;AACJ","sourcesContent":["@font-face {\n    font-family: 'Noto SansThai';\n    src: url('../assets/IBMPlexSansThai-Medium.eot');\n    src: local('☺'), url('../assets/IBMPlexSansThai-Medium.woff') format('woff'), url('../assets/IBMPlexSansThai-Medium.ttf') format('truetype'), url('../assets/IBMPlexSansThai-Medium.svg') format('svg');\n    font-weight: normal;\n    font-style: normal;\n    font-display: swap;\n}\n\nhtml, body, #root {\n    height: 100%;\n    background-color: #F9FBFD;\n    font-family: 'Noto SansThai' !important;\n}\n\n#root {\n    min-height: 100%;\n    height: auto;\n    display: flex;\n    flex-direction: column;\n}\n\n#body, .p-top {\n    padding-top: 55px;\n}\n\n#body {\n    min-height: calc(100% - 50px);\n}\n\n.fw-bold {\n    font-weight: 600 !important;\n}\n\n.rounded-25 {\n    border-radius: 10% !important;\n}\n\n.rounded-left {\n    border-radius: .25rem 0 0 .25rem !important;\n}\n\n.rounded-right-white {\n    border-right: 1px solid #fff;\n    ;\n}\n\n.pointer {\n    cursor: pointer;\n}\n\n.cursor-default {\n    cursor: default;\n}\n\n.min-width-nav {\n    min-width: calc((100vw - 780px) / 2);\n}\n\n.bg-yellow {\n    background-color: #FFC107;\n}\n\n.dropdown-toggle.toggle-end::after {\n    float: right;\n    margin-top: 10px;\n}\n\n.thumbnail-card {\n    width: auto;\n    height: 480px;\n    padding-top: 480px;\n    position: relative;\n}\n\n.thumbnail-img {\n    border-top-left-radius: calc(0.25rem - 1px);\n    border-top-right-radius: calc(0.25rem - 1px);\n    object-fit: cover;\n    vertical-align: bottom;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: #fff;\n    z-index: 0;\n}\n\n.text-potion {\n    color: #148B9E;\n}\n\n.text-gray {\n    color: #DAE2EB;\n}\n\n.text-orange {\n    color: #fa7300\n}\n\n.labels-block {\n    display: inline-block;\n    width: 40px;\n    height: 10px;\n    margin-right: 5px;\n    vertical-align: top;\n    margin-top: 2px;\n}\n\n.line-height-2 {\n    line-height: 1.2;\n}\n\n.fs-7 {\n    font-size: 0.8rem !important;\n}\n\n.navbar-nav.nav-main .nav-link.active {\n    color: #FFFFFF;\n}\n\n.w-webkit-fill-available {\n    width: -webkit-fill-available;\n}\n\n.btn-info-old {\n    color: #fff;\n    background-color: #17a2b8;\n    border-color: #17a2b8;\n}\n\n.btn-info-old:not(:disabled):not(.disabled).active, .btn-info-old:not(:disabled):not(.disabled):active, .show>.btn-info-old.dropdown-toggle {\n    color: #fff;\n    background-color: #117a8b;\n    border-color: #10707f;\n}\n\n.btn-info-old:hover {\n    color: #fff;\n    background-color: #138496;\n    border-color: #117a8b;\n}\n\n.btn-info-old.focus, .btn-info-old:focus {\n    color: #fff;\n    background-color: #138496;\n    border-color: #117a8b;\n    box-shadow: 0 0 0 0.2rem rgb(58 176 195 / 50%);\n}\n\n.btn-egg {\n    color: #212529;\n    background-color: #FFECB2;\n    border-color: #FFECB2;\n}\n\n.btn-egg:not(:disabled):not(.disabled).active, .btn-egg:not(:disabled):not(.disabled):active, .show>.btn-egg.dropdown-toggle {\n    color: #212529;\n    background-color: #ffe598;\n    border-color: #fddb76;\n}\n\n.btn-egg:hover {\n    color: #212529;\n    background-color: #fcdf88;\n    border-color: #ffe598;\n}\n\n.btn-egg.focus, .btn-egg:focus {\n    color: #212529;\n    background-color: #fcdf88;\n    border-color: #ffe598;\n    box-shadow: 0 0 0 0.2rem rgb(252 223 136 / 50%);\n}\n\n.modal-backdrop {\n    background-color: #FFFFFF;\n}\n\n.modal-backdrop.show {\n    opacity: .9;\n}\n\n.bg-sky {\n    background-color: #F9FBFD;\n}\n\n.text-info-old {\n    color: #148B9E;\n}\n\n.very-small {\n    font-size: .8rem;\n}\n\n.min-height-90vh {\n    min-height: 90vh;\n}\n\n.table {\n    --bs-table-striped-bg: #F9FBFD;\n}\n\n.table-striped>tbody>tr:nth-of-type(odd) {\n    --bs-table-accent-bg: var(--bs-table-striped-bg);\n    color: var(--bs-table-striped-color);\n}\n\n.page-link {\n    color: #212529;\n}\n\n.page-link:focus {\n    color: #FFC107;\n    background-color: #e9ecef;\n    box-shadow: 0 0 0 0.25rem rgb(255 193 7 / 25%);\n}\n\n.page-link:hover {\n    color: #FFC107;\n    background-color: #e9ecef;\n    border-color: #dee2e6;\n}\n\n.page-item.active .page-link {\n    background-color: #FFC107;\n    border-color: #FFC107;\n}\n\n.white-space-pre-wrap {\n    white-space: pre-wrap;\n}\n\n.dropdown-toggle.toggle-end::after {\n    float: right;\n    margin-top: 10px;\n}\n\n.clear-block-user-search {\n    position: absolute;\n    right: 50px;\n    top: 9px;\n    z-index: 3;\n}\n\n@media (min-width: 992px) {\n    .navbar-nav.nav-main .nav-link.active {\n        border-bottom: 4px solid #FFFFFF;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
